(() => {
  if (window.cbSizeLoaded) return;
  window.cbSizeLoaded = true;
  // Größenempfehlung: liest Nutzermaße aus Cookie, holt API-Ergebnis und aktualisiert Drawer & Produktkarten.
  const cookieName = 'cb_sizefinder';
  const cache = new Map();

  const readCookie = () => {
    try {
      const match = document.cookie.split('; ').find((row) => row.startsWith(`${cookieName}=`));
      if (!match) return null;
      const raw = decodeURIComponent(match.split('=')[1] || '');
      return JSON.parse(raw);
    } catch (e) { return null; }
  };

  const saveCookie = (height, leg) => {
    try {
      const value = encodeURIComponent(JSON.stringify({ height, leg }));
      document.cookie = `${cookieName}=${value}; path=/; max-age=${60 * 60 * 24 * 30}`;
    } catch (e) { /* ignore */ }
  };

  const fetchSize = (article, height, leg) => {
    // API-Aufruf mit einfachem Promise-Cache, damit Mehrfachanfragen vermieden werden.
    const key = `${article}:${height}:${leg}`;
    if (cache.has(key)) return cache.get(key);
    const url = `https://cb-tm-apps-b674b321c61f.herokuapp.com/size-recommendation?articleNumber=${encodeURIComponent(article)}&height=${encodeURIComponent(height)}&leg=${encodeURIComponent(leg)}`;
    const p = fetch(url, { headers: { Accept: 'application/json' }, mode: 'cors', credentials: 'omit' })
      .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(() => null);
    cache.set(key, p);
    return p;
  };

  const getContext = (root) => {
    // Relevante Elemente je Size-Finder-Instanz ermitteln.
    const form = root.querySelector('[data-size-finder-form]') || root.querySelector('form');
    const resultEl = root.querySelector('[data-size-finder-result]') || document.querySelector(`[data-size-finder-id="${root.dataset.sizeFinderId}"] [data-size-finder-result]`) || document.querySelector('[data-size-finder-result]');
    const triggerBtn = root.querySelector('button[name="size-finder-trigger"]');
    const triggerLabel = triggerBtn?.querySelector('.size-finder__label');
    const drawer = document.getElementById(root.dataset.sizeFinderId) || root.querySelector('x-drawer');
    const scoped = root.querySelector(`[data-size-finder-id="${root.dataset.sizeFinderId}"]`) || drawer?.querySelector(`[data-size-finder-id="${root.dataset.sizeFinderId}"]`);
    const heightInput = scoped?.querySelector('input[name="height"]') || root.querySelector('input[name="height"]') || drawer?.querySelector('input[name="height"]') || document.querySelector('input[name="height"]');
    const legInput = scoped?.querySelector('input[name="leg"]') || root.querySelector('input[name="leg"]') || drawer?.querySelector('input[name="leg"]') || document.querySelector('input[name="leg"]');
    const articleNumber = root.dataset.sizeArticleNumber || root.dataset.articleNumber || root.dataset.article;
    return { form, resultEl, triggerBtn, triggerLabel, heightInput, legInput, articleNumber };
  };

  const processRoot = (root, showLoading = true) => {
    // Validierung, API-Call und Rendering für einen Size-Finder.
    const { resultEl, triggerLabel, triggerBtn, heightInput, legInput, articleNumber } = getContext(root);
    const messages = root.dataset.messages ? JSON.parse(root.dataset.messages) : {};
    if (!heightInput || !legInput || !articleNumber) return;

    const setButtonLabel = (data) => {
      if (!triggerLabel) return;
      const base = triggerBtn?.dataset.baseLabel || triggerLabel.textContent;
      if (!data || !data.recommendedSize) {
        triggerLabel.textContent = base;
        return;
      }
      const sizes = data.secondRecommendedSize ? `${data.recommendedSize}, ${data.secondRecommendedSize}` : data.recommendedSize;
      triggerLabel.textContent = `Deine passende Größe: ${sizes}`;
    };

    const renderResult = (data) => {
      const parts = [];
      if (data?.legRatioOutOfBounds) {
        parts.push(`<p class="size-finder__msg">${messages.legOut || ''}</p>`);
      }
      if (data?.recommendedSize) {
        const primary = data.recommendedSize;
        const secondary = data.secondRecommendedSize;
        const between = secondary ? `<p class="size-finder__msg--muted">Hinweis: Du liegst zwischen diesen beiden Größen.</p>` : '';
        const sizeLine = secondary
          ? `<div class="size-finder__size-line"><span class="lead">Deine Größe&nbsp;</span><strong class="h1 size-finder__size-main">${primary}</strong><span class="lead">&nbsp;oder&nbsp;</span><strong class="h1 fw-bold size-finder__size-alt">${secondary}</strong></div>${between}`
          : `<div class="size-finder__size-line"><span class="lead">Deine Größe&nbsp;</span><strong class="h1 size-finder__size-main">${primary}</strong></div>`;
        parts.push(sizeLine);
      }
      if (data?.sizesExist === false) {
        parts.push(`<p class="size-finder__msg size-finder__msg--warning">${messages.noSize || ''}</p>`);
      }
      parts.push(`<p class="size-finder__note text-xs">${messages.note || ''}</p>`);
      if (resultEl) {
        resultEl.innerHTML = parts.join('');
        resultEl.hidden = false;
        resultEl.removeAttribute('hidden');
        setButtonLabel(data);
      }
    };

    const h = heightInput.value?.trim();
    const l = legInput.value?.trim();
    if (!h || !l) {
      if (resultEl) {
        resultEl.hidden = false;
        resultEl.textContent = 'Bitte fülle Körpergröße und Schrittlänge aus.';
        resultEl.classList.add('is-error');
      }
      return;
    }
    if (showLoading && resultEl) {
      resultEl.hidden = false;
      resultEl.textContent = 'Berechne...';
      resultEl.classList.remove('is-error', 'is-muted');
    }

    fetchSize(articleNumber, h, l)
      .then((data) => {
        if (!data) {
          if (resultEl) {
            resultEl.textContent = 'Entschuldigung, etwas ist schiefgelaufen. Bitte versuche es erneut.';
            resultEl.classList.add('is-error');
          }
          return;
        }
        renderResult(data);
        saveCookie(h, l);
      })
      .catch(() => {
        if (resultEl) {
          resultEl.textContent = 'Entschuldigung, etwas ist schiefgelaufen. Bitte versuche es erneut.';
          resultEl.classList.add('is-error');
        }
      });
  };

  const initSizeFinder = () => {
    // Drawer-Instanzen initialisieren und Events binden.
    document.querySelectorAll('[data-size-finder]').forEach((root) => {
      if (root.dataset.sizeFinderInit === 'true') return;
      root.dataset.sizeFinderInit = 'true';

      const ctx = getContext(root);
      if (!ctx.articleNumber) {
        return;
      }

      const messages = {
        noSize: 'Leider können wir dir keine Rahmengröße empfehlen. Bitte kontaktiere uns für eine individuelle Beratung.',
        legOut: 'Die errechnete Rahmengröße wurde ausschließlich anhand deiner Körpergröße berechnet, da deine Eingabe zur Schrittlänge außerhalb des üblichen Wertebereichs liegt.',
        note: 'Bitte beachte, dass es sich hier nur um eine Empfehlung zu einer passenden Rahmengröße handelt. Diese kann keine individuelle Beratung und Probefahrt bei uns vor Ort ersetzen.'
      };

      root.dataset.messages = JSON.stringify(messages);

      const handler = (e) => { e.preventDefault(); processRoot(root, true); };
      ctx.form?.addEventListener('submit', handler, true);
      const submitBtn = root.querySelector('button[name="size-finder-submit"]');
      submitBtn?.addEventListener('click', handler, true);

      // Button-Label automatisch setzen, wenn Cookie vorhanden
      const cookie = readCookie();
      if (cookie?.height && cookie?.leg && ctx.articleNumber) {
        if (!ctx.heightInput.value) ctx.heightInput.value = cookie.height;
        if (!ctx.legInput.value) ctx.legInput.value = cookie.leg;
        fetchSize(ctx.articleNumber, cookie.height, cookie.leg).then((data) => {
          if (data) {
            const sizes = data.secondRecommendedSize ? `${data.recommendedSize}, ${data.secondRecommendedSize}` : data.recommendedSize;
            const labelEl = root.querySelector('.size-finder__label');
            const base = submitBtn?.dataset.baseLabel || labelEl?.textContent || 'Finde deine Größe';
            if (data.recommendedSize && labelEl) {
              labelEl.textContent = `Deine passende Größe: ${sizes}`;
            } else if (labelEl) {
              labelEl.textContent = base;
            }
          }
        });
      }
    });
  };

  let lastSubmitAt = 0;

  const handleSubmit = (e) => {
    // Button-Klick global abfangen (auch bei Custom-Buttons/Shadow DOM).
    const path = (typeof e.composedPath === 'function') ? e.composedPath() : [];
    const btnFromPath = path.find((el) => el && el.getAttribute && el.getAttribute('name') === 'size-finder-submit');
    const btn = btnFromPath || e.target.closest?.('button[name="size-finder-submit"]');
    if (!btn) return;
    const now = Date.now();
    if (now - lastSubmitAt < 250) return;
    lastSubmitAt = now;
    e.preventDefault();
    const root = btn.closest('[data-size-finder]');
    if (!root) return;
    if (!root.dataset.messages) {
      root.dataset.messages = JSON.stringify({
        noSize: 'Leider können wir dir keine Rahmengröße empfehlen. Bitte kontaktiere uns für eine individuelle Beratung.',
        legOut: 'Die errechnete Rahmengröße wurde ausschließlich anhand deiner Körpergröße berechnet, da deine Eingabe zur Schrittlänge außerhalb des üblichen Wertebereichs liegt.',
        note: 'Bitte beachte, dass es sich hier nur um eine Empfehlung zu einer passenden Rahmengröße handelt. Diese kann keine individuelle Beratung und Probefahrt bei uns vor Ort ersetzen.'
      });
    }
    processRoot(root, true);
  };

  const handleFormSubmit = (e) => {
    // Enter-Submit im Formular behandeln.
    const form = e.target.closest('[data-size-finder-form]');
    if (!form) return;
    e.preventDefault();
    const root = form.closest('[data-size-finder]');
    if (!root) return;
    processRoot(root, true);
  };

  const handleFocusPins = (e) => {
    // Klicks auf die Messpunkte neben der Grafik fokussieren das entsprechende Feld.
    const btn = e.target.closest('[data-focus]');
    if (!btn) return;
    const root = btn.closest('[data-size-finder]');
    if (!root) return;
    const { heightInput, legInput } = getContext(root);
    const target = btn.dataset.focus === 'height' ? heightInput : legInput;
    target?.focus();
  };

  const initCardSizes = () => {
    // Größen für Produktkarten anhand gespeicherter Maße anzeigen.
    const cookie = readCookie();
    if (!cookie?.height || !cookie?.leg) return;
    const nodes = Array.from(document.querySelectorAll('[data-size-article]'));
    if (!nodes.length) return;
    const grouped = nodes.reduce((m, el) => {
      const art = el.dataset.sizeArticle;
      if (!art) return m;
      (m[art] = m[art] || []).push(el);
      return m;
    }, {});
    Object.entries(grouped).forEach(([article, els]) => {
      fetchSize(article, cookie.height, cookie.leg).then((data) => {
        if (!data || data.sizesExist === false) return;
        els.forEach((root) => {
          const list = root.querySelector('[data-size-list]');
          const label = root.querySelector('.product-card__sizes-label');
          if (!list) return;
          const spans = [];
          if (data.recommendedSize) spans.push(`<span class="product-card__sizes-badge">${data.recommendedSize}</span>`);
          if (data.secondRecommendedSize) spans.push(`<span class="product-card__sizes-badge">${data.secondRecommendedSize}</span>`);
          if (spans.length) {
            list.innerHTML = spans.join(' ');
            label?.removeAttribute('hidden');
            root.hidden = false;
          }
        });
      });
    });
  };

  const init = () => {
    initSizeFinder();
    initCardSizes();
  };

  const ready = () => {
    init();
    document.addEventListener('click', handleSubmit, true);
    document.addEventListener('submit', handleFormSubmit, true);
    document.addEventListener('click', handleFocusPins, true);
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:reorder', init);
    document.addEventListener('shopify:section:select', init);
    document.addEventListener('shopify:section:deselect', init);
    window.addEventListener('pageshow', init);

    const mo = new MutationObserver((muts) => {
      for (const mut of muts) {
        if (mut.addedNodes && mut.addedNodes.length) {
          if (Array.from(mut.addedNodes).some(n => n.nodeType === 1 && n.querySelector?.('[data-size-finder]'))) {
            init();
            break;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    ready();
  } else {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  }
})();
